<template>
  <div class="div_btn_inline">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :small="buttonSizeSmall"
          fab
          v-if="idAccion == 1 && icono"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-plus
          </v-icon>
        </v-btn>
        <v-btn
          :small="buttonSizeSmall"
          v-if="idAccion == 1 && !icono"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-plus
          </v-icon>
          Agregar respuesta
        </v-btn>
      </template>
      <span>Agregar respuesta</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :small="buttonSizeSmall"
          v-if="idAccion == 2 && icono"
          color="info" 
          v-bind="attrs"
          v-on="on"
          class="mx-2"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-pencil
          </v-icon>
          Editar
        </v-btn>
        <v-btn
          :small="buttonSizeSmall"
          v-if="idAccion == 2 && !icono"
          color="info" 
          v-bind="attrs"
          v-on="on"
          class="mx-2"
          @click.stop="dialog = true"
        >
          <v-icon :small="buttonSizeSmall">
            mdi-pencil
          </v-icon>
          Editar respuesta
        </v-btn>
      </template>
      <span>Editar respuesta</span>
    </v-tooltip>

    <v-dialog
      :name="'dialog_form_respuesta_' + idCatRespuesta"
      :key="'dialog_form_respuesta_' + idCatRespuesta"
      v-model="dialog"
      width="500"
      max-width="500"
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-h5 blue darken-4 lighten-2">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="h5" style="color:white!important;">
                <v-icon color="white">{{ idAccion == 1 ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
                {{ idAccion == 1 ? 'Agregar Respuesta' : 'Editar Respuesta' }}
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-form 
            class="mt-5 my-5"
            ref="form" 
            v-model="valid" 
            :lazy-validation="lazy"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="respuesta"
                  :loading="loading"
                  label="Respuesta *"
                  :rules="[(v) => !!v || 'Campo obligatorio']"
                  outlined
                  dense
                  required
                ></v-text-field>  
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="valorRespuesta"
                  :loading="loading"
                  label="Valor Respuesta *"
                  type="number"
                  outlined
                  dense
                  required
                ></v-text-field>  
              </v-col>
            </v-row>

              <v-row class="mb-3">
                <v-col cols="12">
                  <v-switch 
                    v-model="capturaLibre" 
                    class="mx-2" 
                    label="¿Es captura libre?" 
                    required  
                    style="justify-content: center; display: grid;  margin-top:5px;"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <small>* Campo obligatorio</small>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  class="mx-2"
                  color="default"
                  :loading="loadingSave"
                  @click="dialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  class="mx-2"
                  color="success"
                  :disabled="!valid"
                  :loading="loadingSave"
                  @click="guardar"
                >
                <v-icon class="mr-2">mdi-floppy</v-icon>
                  guardar Respuesta
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      :name="'snackbar_dialog_form_respuesta_' + idCatRespuesta"
      :key="'snackbar_dialog_form_respuesta_' + idCatRespuesta"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { postRespuesta, putRespuesta } from "@/api";

export default {
  name: "DialogFormRespuesta",
  components: {
  },
  props: {
    idAccion: {
      type: Number,
      required: true
    },    
    idPreguntaProp: {
      type: Number,
      required: true
    },
    objRespuesta: {
      type: Object,
      default: function () {
        return {
          idCatRespuesta: 0,
          idPregunta: 0,
          respuesta: '',
          valorRespuesta: 0,                  
          capturaLibre: false          
        }
      }
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    },
    buttonSizeSmall: {
      type: Boolean,
      default: false
    },
    icono:  {
      type: Boolean, 
      default: false
    },    
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingSave: false,

      valid: false,
      lazy: false,

      flagInitForm: 1,
      idAccionForm: 1,

      searchGrupo: null,

      idCatRespuesta: 0,
      idPregunta: 0,
      respuesta: '',
      valorRespuesta: 0,
      capturaLibre: false,

      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",

      banLimpiarDatos: 0,
    };
  },
  computed: {
  },
  watch:{
    dialog: {
      handler (newValue, oldValue) {
        if(this.$refs.form != undefined && newValue == true){
          this.$refs.form.resetValidation();
        }
        if(newValue == true){
          this.idCatRespuesta = this.objRespuesta.idCatRespuesta;
          this.idPregunta = this.idAccion == 1 ? this.idPreguntaProp : this.objRespuesta.idPregunta;
          this.respuesta = this.objRespuesta.respuesta;
          this.valorPregunta = this.objRespuesta.valorPregunta;
          this.capturaLibre = this.objRespuesta.capturaLibre;
        }
        else{
          this.idCatRespuesta = 0;
          this.idPregunta = 0;
          this.respuesta = '';
          this.valorPregunta = 0;
          this.capturaLibre = false;
        }
			},
    },
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    async guardar(){
      var self = this;

      if (self.$refs.form.validate()) {

        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
            
        try {
          let response;

          var obj = {
            idCatRespuesta: this.idCatRespuesta,
            idPregunta: this.idPregunta,
            respuesta: this.respuesta,
            valorRespuesta: this.valorRespuesta,
            capturaLibre: this.capturaLibre
          }

          if(obj.idCatRespuesta == 0){
            response = await postRespuesta(obj);
          }
          else{
            response = await putRespuesta(obj);
          }

          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto") {
                self.snackbarTexto = "Respuesta guardada con éxito";
                self.snackbarColor = "success";
                self.snackbar = true;

                self.fnOnSave();

                self.dialog = false;
              }
            } else {
              self.snackbarTexto = "DialogFormRespuesta: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "DialogFormRespuesta: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "DialogFormRespuesta: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    },
  },  
};
</script>